// KPICard.js - KPI 카드 컴포넌트 (수치형 인디케이터)
import React, { useState, useEffect } from 'react';
import { FiTrendingUp, FiTrendingDown, FiMinus } from 'react-icons/fi';

const KPICard = ({ 
  value, 
  label, 
  icon: Icon,
  unit = "",
  trend = null, // { value: 5, direction: 'up' | 'down' | 'neutral' }
  theme = 'dark',
  color = '#00BFFF',
  animate = true,
  onClick = null, // 클릭 핸들러 추가
}) => {
  const isDark = theme === 'dark';
  const [displayValue, setDisplayValue] = useState(animate ? 0 : value);

  // 숫자 애니메이션 효과
  useEffect(() => {
    if (!animate || value === displayValue) return;

    const duration = 1000; // 1초
    const steps = 60;
    const increment = (value - displayValue) / steps;
    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      if (currentStep >= steps) {
        setDisplayValue(value);
        clearInterval(timer);
      } else {
        setDisplayValue(prev => prev + increment);
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [value, animate, displayValue]);

  // 트렌드 아이콘 및 색상
  const getTrendIcon = () => {
    if (!trend) return null;
    if (trend.direction === 'up') return <FiTrendingUp size={16} color="#66BB6A" />;
    if (trend.direction === 'down') return <FiTrendingDown size={16} color="#FF5252" />;
    return <FiMinus size={16} color={isDark ? '#B0B0B0' : '#666'} />;
  };

  const getTrendColor = () => {
    if (!trend) return isDark ? '#B0B0B0' : '#666';
    if (trend.direction === 'up') return '#66BB6A';
    if (trend.direction === 'down') return '#FF5252';
    return isDark ? '#B0B0B0' : '#666';
  };

  return (
    <div style={{
      padding: '20px',
      backgroundColor: isDark ? '#1e1e1e' : '#ffffff',
      border: `1px solid ${isDark ? '#333' : '#e8e8e8'}`,
      borderRadius: '8px',
      transition: 'all 0.2s',
      cursor: onClick ? 'pointer' : 'default'
    }}
    onClick={onClick || undefined}
    onMouseEnter={(e) => {
      if (onClick) {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = `0 4px 12px ${color}40`;
      }
    }}
    onMouseLeave={(e) => {
      if (onClick) {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }
    }}
    >
      {/* 아이콘 및 라벨 */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px'
      }}>
        {Icon && (
          <div style={{
            width: '36px',
            height: '36px',
            borderRadius: '8px',
            backgroundColor: `${color}20`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Icon size={20} color={color} />
          </div>
        )}
        <div style={{
          fontSize: '13px',
          fontWeight: 500,
          color: isDark ? '#B0B0B0' : '#666'
        }}>
          {label}
        </div>
      </div>

      {/* 값 */}
      <div style={{
        fontSize: '32px',
        fontWeight: 700,
        color: color,
        lineHeight: 1.2,
        marginBottom: '8px'
      }}>
        {Math.round(displayValue).toLocaleString()}{unit}
      </div>

      {/* 트렌드 */}
      {trend && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          fontSize: '12px',
          color: getTrendColor()
        }}>
          {getTrendIcon()}
          <span style={{ fontWeight: 600 }}>
            {Math.abs(trend.value)}%
          </span>
          <span style={{ color: isDark ? '#808080' : '#999' }}>
            전일 대비
          </span>
        </div>
      )}
    </div>
  );
};

export default KPICard;

